import React, { useEffect, useState, Fragment, useContext } from "react";
import Panel from "../Panel";
import {
  Form,
  Message,
  FormInput,
  Grid,
  GridColumn,
  GridRow,
  FormGroup,
  Divider,
  Dropdown,
  Button,
  Checkbox
} from "semantic-ui-react";
import { useFormik } from "formik";
import "../OrderComponents/ZenMigration.css";
import addressSearchRequest from "../../libs/requests/addressSearch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, compareAsc } from "date-fns";
import postZenOrder from "../../libs/requests/postZenOrder";
import { ActivationDate } from "./ActivationDate";
import { selectErrorBannerMessage } from "../../libs/zenErrorBannerMessage";
import { getSupplier, supplierKey } from "../../libs/sessionVariable";
import { getRealms } from "../../libs/requests/getPartnerDetails";
import { checkUsernameValid, generateShortID } from "../../libs/utils";
import * as utilities from "./Utilities";
import { authContext } from "../../containers/AuthProvider";

export default function ZenGFastMigrationOrder() {
  const selectedProduct = sessionStorage.getItem("selectedProduct");

  const selectedPhone = sessionStorage.getItem("customerDetails");
  const requestPhone = JSON.parse(selectedPhone);

  const product = JSON.parse(selectedProduct);
  const postCode = { postCode: product?.orderDetails?.requestPostCode };
  const { addressReferenceNumber } =
    product?.orderDetails?.goldAddressKeyAvailabilityRequest || null;;
  const [errorMessage, setErrorMessage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [level, setLevel] = useState({ careLevelField: "Standard" });
  const [weighting, setTrafficWeighting] = useState({
    trafficWeightingField: "Standard",
  });
  const [zenReference, setZenReference] = useState();
  const todaysDate = new Date();
  const [radioButtons, setRadioButtons] = useState("0");
  const [addressValue, setAddressValue] = useState({
    addressField: {
      addressReferenceNumber: "",
      districtCode: "",
      qualifier: "",
    },
  });
  const [usernameValue, setUsernameValue] = useState("");
  const [usernameMessage, setUsernameMessageResults] = useState("");
  const [isActivationDateVisible, setActivationDateVisible] = useState(true);
  const [supplier, setSupplier] = useState("");
  const [realm, setRealm] = useState("dslnet");
  const [realms, setRealms] = useState(["dslnet"]);
  const [isL2Customer, setIsL2Customer] = useState(false);
  const { logout, userLoggedIn, permissions } = useContext(authContext);
  const [isRetryOrder, setIsRetryOrder] = useState(false);
  const [pricingOption, setPricingOption] = useState("rateCard");
  const [bespokePrice, setBespokePrice] = useState("");
  const [router, setSelectedRouter] = useState("None");
  const [requierments, setRequierments] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [deliveryOptions, setSelectedDelivery] = useState("");
  const [showDeliveryValidation, setShowDeliveryValidation] = useState(false);
  const [isBureauReseller, setIsBureauReseller] = useState(false);
  const [bureauEndCustomer, setBureauEndCustomer] = useState("");

  const handleBureauResellerChange = (e, { checked }) => {
    setIsBureauReseller(checked);
    setFieldValue("isBureauReseller", checked);
    // Clear end customer field when unchecked
    if (!checked) {
      setBureauEndCustomer("");
      setFieldValue("bureauEndCustomer", "");
    }
    // Trigger validation
    setTimeout(() => formik.validateForm(), 0);
  };

  const handleBureauEndCustomerChange = (e) => {
    setBureauEndCustomer(e.target.value);
    setFieldValue("bureauEndCustomer", e.target.value);
  };

  useEffect(() => {
    const details = sessionStorage.getItem("selectedProduct");
    const availability = JSON.parse(details);
    setRequierments(availability?.requierments || []);
    setProductOptions(availability?.orderDetails?.productOptions || []);
  }, []);

  
  const handleDeliveryChange = (e, { value }) => {
    setSelectedDelivery(value);
    setFieldValue("deliveryOptions", value);
    setTimeout(() => formik.validateForm(), 0);
  };

  const handleRouterChange = (e, { value }) => {
    setSelectedRouter(value);
    setFieldValue("router", value);
    setShowDeliveryValidation(value !== "None");
    if (value === "None") {
      setSelectedDelivery("");
      setFieldValue("deliveryOptions", "");
    }
    setTimeout(() => formik.validateForm(), 0);
  };

  const handlePricingOptionChange = (e, { value }) => {
    setPricingOption(value);
  };

  const handlePriceChange = (e) => {
    setBespokePrice(e.target.value);
    setFieldValue("bespokePrice", e.target.value);
  };

  const handleRetryChange = () => {
    setIsRetryOrder((prev) => !prev);
  };

  useEffect(() => {
    async function fetchSuppllier() {
      const defaultSupplier = await getSupplier(supplierKey.ZEN, false);
      setSupplier(defaultSupplier);
    }
    fetchSuppllier();
  });

  useEffect(() => {
    (async () => {
      const l2 = await utilities.isL2();

      if (l2) {
        setIsL2Customer(l2);
      }

      if (!isL2Customer) {
        const realms = await getRealms();
        setRealms(realms);
        if (realms?.[0]?.value) setRealm(realms[0].value);
      }
    })();
  }, []);

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const [startDate, setStartDate] = useState(new Date(tomorrow));

  const careLevels = [
    { key: 0, value: "Standard", text: "Standard", flag: 0 },
    { key: 1, value: "Enhanced", text: "Enhanced", flag: 1 },
    { key: 2, value: "Critical", text: "Critical", flag: 2 },
  ];

  const trafficWeighting = [
    { key: 0, value: "Standard", text: "Standard", flag: 0 },
  ];

  const ips = [
    { key: 1, value: 1, text: "1", flag: 1 },
    { key: 4, value: 4, text: "4", flag: 4 },
  ];

  useEffect(() => {
    function getDatePicker() {
      const response = (
        <DatePicker
          selected={format(startDate, "dd.MM.yyyy")}
          onChange={(date) => setStartDate(format(date, "dd.MM.yyyy"))}
        />
      );
    }
    getDatePicker();
  }, []);

  const addressSearch = async (postCode) => {
    try {
      return await addressSearchRequest(postCode);
    } catch (err) {
      console.log(err);
    }
  };

  const getAddresses = async (postCode) => {
    const result = await addressSearch(postCode);
    const optionsList = [];

    result.forEach(function (element) {
      optionsList.push({
        key: element.addressReference,
        value: element.addressReference,
        text: element.address,
        flag: element.addressReference,
      });
    });
    return optionsList;
  };

  const [addressResults, setAddressResults] = useState([]);

  useEffect(() => {
    const raw = sessionStorage.getItem('customerDetails');
    if (!raw) return;
    const { selectedAddress } = JSON.parse(raw);
    if (!selectedAddress?.addressReference) return;
    const option = {
      key: selectedAddress.addressReference,
      value: selectedAddress.addressReference,
      text: selectedAddress.address,
      flag: selectedAddress.addressReference,
    };
    setAddressResults([option]);
    setAddressValue({ addressField: selectedAddress.addressReference });
    setFieldValue('addressField', selectedAddress.addressReference);
  }, []);

  const handleRadioChange = (e) => {
    setRadioButtons(e.currentTarget.value);
    setFieldValue("noOfIps", e.currentTarget.value);
  };

  const handleAddressChange = (event, result) => {
    const { name, value } = result || event.target;
    setAddressValue({ ...addressValue, [name]: value });
    setFieldValue("addressField", value);
  };

  const handleCareLevelChange = (event, result) => {
    const { name, value } = result || event.target;
    setLevel({ ...level, [name]: value });
  };

  const handleTrafficWeightingChange = (event, result) => {
    const { name, value } = result || event.target;
    setTrafficWeighting({ ...weighting, [name]: value });
  };

  const handleRealmChange = async (event, result) => {
    const { value } = result || event.target;
    setRealm(value);
    setFieldValue("realm", value);

    setUsernameMessageResults(await checkUsernameValid(usernameValue, value));
  };

  const handleUsernameChange = async (e, result) => {
    setUsernameValue(e.currentTarget.value);
    setFieldValue("usernameField", e.currentTarget.value);

    setUsernameMessageResults(
      await checkUsernameValid(e.currentTarget.value, realm)
    );
  };

  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue,
    isValid,
    errors,
    ...formik
  } = useFormik({
    onSubmit,
    validate,
    validateOnChange: true,
    validateOnMount: true,
    initialValues: {
      pricingOption: "rateCard",
      bespokePrice: "",
      siteInformation: "",
      addressField: {
        addressReferenceNumber: "",
        districtCode: "",
        qualifier: "",
      },
      noOfIps: "1",
      orderRef: "",
      contactName: "",
      usernameField: "",
      password: "",
      contactName: "",
      contactTel: "",
      linkedOrderRef: "",
      rid: "",
      router: "None",
      deliveryOptions: "",
    },
  });

  function validate({
    linkedOrderRef,
    usernameField,
    password,
    addressField,
    noOfIps,
    orderRef,
    contactTel,
    contactName,
    rid,
    isBureauReseller,
    bureauEndCustomer,
  }) {
    const errors = {};
    const address =
      addressField.qualifier === "Silver"
        ? addressField.uprn
        : addressField.addressReferenceNumber;

        if (!permissions.isNimansTenant && (typeof rid == "undefined" || !rid.length)) {
          errors.rid = true;
        }

    if (!contactTel.length) {
      errors.contactTel = true;
    }

    if (!contactName.length) {
      errors.contactName = true;
    }

    if (!address) {
      errors.addressField = true;
    }

    if (!noOfIps.length && !isL2Customer) {
      errors.noOfIps = true;
    }

    if (!orderRef.length) {
      errors.orderRef = true;
    }

    if (!usernameField && !isL2Customer) {
      errors.username = true;
    }

    if (!password.length && !isL2Customer) {
      errors.password = true;
    }

    if (values.router !== "None" && !values.deliveryOptions || values.router !== "None" && values.deliveryOptions === "") {
      errors.deliveryOptions =
        "Delivery option is required when a router is selected";
    }

    if (
      permissions?.isNimansTenant &&
      isBureauReseller &&
      (!bureauEndCustomer || !bureauEndCustomer.length)
    ) {
      errors.bureauEndCustomer =
        "End customer name is required for Bureau reseller orders";
    }

    return errors;
  }

  async function onSubmit({
    linkedOrderRef,
    usernameField,
    password,
    addressField,
    noOfIps,
    activationDateField,
    orderRef,
    contactName,
    contactTel,
    rid,
  }) {
    setIsLoading(true);

    const selectedAddress =
      addressField?.qualifier === "Gold"
        ? addressResults.find(
            (element) =>
              element.key.addressReferenceNumber ===
              addressField?.addressReferenceNumber
          )
        : addressResults.find(
            (element) => element.key.uprn === addressField?.uprn
          );

    const addressDetails = selectedAddress.text;
    const address = addressDetails.split(",");
    const isPremiseNameOrThoroughfare = parseInt(address[0]);
    const usePremiseName = isNaN(isPremiseNameOrThoroughfare);
    const premiseName = usePremiseName ? address[0] : null;
    const thoroughFareNumber = !usePremiseName ? address[0] : null;
    let activationDate = !document.getElementById("activationDateField")
      ? ""
      : document.getElementById("activationDateField").defaultValue;
    let year = activationDate.substring(6, 10);
    let month = activationDate.substring(3, 5) - 1; // JavaScript months are 0-indexed
    let day = activationDate.substring(0, 2);
    let dateObject = new Date(year, month, day, 12, 0, 0);
    activationDate = dateObject.toISOString();

    try {
      const javaObject = {
        availabilityReference: product.orderDetails.availabilityReference,
        installationDetails: {
          phoneNumber:
            product.orderDetails && product.orderDetails.accessLines
              ? product.orderDetails.accessLines[0].lineNumber
              : requestPhone.phoneNumber,
          goldAddressKey:
            typeof addressField?.addressReferenceNumber != "undefined"
              ? addressField?.addressReferenceNumber
              : "",
          districtCode: addressField.districtCode,
          address: {
            premiseName: premiseName,
            thoroughfareNumber: thoroughFareNumber,
            thoroughfare: address[1],
            postTown: address[2].trim(),
            postCode: postCode.postCode.trim(),
          },
          uprn:
            typeof addressField?.uprn != "undefined" ? addressField?.uprn : "",
        },
        productCode: product.productCode,
       
        preferredActivationDate: activationDate,
        orderReference: !isRetryOrder
          ? orderRef + "_" + generateShortID()
          : orderRef,
          rid: permissions.isNimansTenant ? 'GLT' : rid,
        endUserContact: {
          fullName: contactName,
          phoneNumber: contactTel,
        },
        ...(!isL2Customer
          ? {
              broadbandCredentials: {
                username: `${usernameField}@${realm}`,
                password: password,
                numberOfIps: parseInt(noOfIps),
              },
            }
          : {}),
      };

      if(productOptions?.length > 0 && productOptions.some(x => x.code === "CareLevel") || productOptions.some(x => x.code === "TrafficWeighting")) {
          
        javaObject.options = [
          {
            type: 1,
            value: level.careLevelField,
          },
          {
            type: 2,
            value: weighting.trafficWeightingField,
          },
        ]
    }

      if (permissions?.rateCard) {
        javaObject.pricingOption = pricingOption;
        if (pricingOption === "bespoke") {
          javaObject.bespokePrice = bespokePrice;
        } else {
          javaObject.pricingOption = "rateCard";
        }
      }

      if (permissions?.rateCard && router !== "None" && router !== "") {
        javaObject.router = router;
      }

      if (permissions?.rateCard && router !== 'None' && router !== '') {
        javaObject.deliveryOptions = deliveryOptions;
      }

      if(permissions?.isNimansTenant){
        javaObject.isBureauReseller = isBureauReseller;
        javaObject.bureauEndCustomer = bureauEndCustomer;
  }

      const body = JSON.stringify(javaObject);
      setErrorMessage([]);
      setZenReference(await postZenOrder(body));
      setErrorMessage([]);
      setIsLoading(false);
    } catch (ex) {
      setErrorMessage([]);
      const errors = selectErrorBannerMessage(ex);
      setErrorMessage(errors);
      setIsLoading(false);
    }
  }

  return (
    <>
      <Panel header={supplier + " " + product.productName}>
        {errorMessage.length !== 0 && (
          <Message
            error
            header="There was some errors with your submission"
            list={errorMessage}
          />
        )}

        {zenReference && (
          <Message
            success
            header="Your submission was successful"
            content={"Order reference: " + zenReference}
          />
        )}
        <Form onSubmit={useFormik.handleSubmit} className="disabled">
          <Grid columns={1}>
            <GridRow>
              <GridColumn>
                <FormGroup>
                  <FormInput
                    style={{ width: "250px" }}
                    inline
                    label="Line Cli"
                    name="lineCLI"
                    id="lineCLI"
                    data-testid="lineCLI"
                    disabled={true}
                    value={
                      product.orderDetails && product.orderDetails.accessLines
                        ? product.orderDetails.accessLines[0].lineNumber
                        : requestPhone.phoneNumber
                    }
                    required
                  />
                </FormGroup>
                <Divider />
                <FormGroup>
                  <FormInput
                    style={{ width: "250px" }}
                    inline
                    label="Product"
                    name="productLabel"
                    data-testid="productCode"
                    disabled={true}
                    value={product.productCode}
                    required
                  />
                </FormGroup>
                <Divider></Divider>
              </GridColumn>
            </GridRow>
            <GridRow>
              <GridColumn>
                <FormGroup>
                  <FormInput
                    style={{ width: "250px" }}
                    inline
                    label="Provision Type"
                    name="provisionLabel"
                    data-testid="provisioningType"
                    disabled={true}
                    value="Migration"
                    required
                  />
                </FormGroup>
                <Divider></Divider>
              </GridColumn>
            </GridRow>
          </Grid>
          <Grid>
            <GridRow>
              <GridColumn>
                <FormGroup>
                  <Form.Field
                    inline
                    name="addressLabel"
                    data-testid="addressDropDown"
                    label={"Address  - ".concat(postCode.postCode)}
                    disabled={true}
                    required
                  ></Form.Field>
                </FormGroup>
                <FormGroup>
                  <Dropdown
                    placeholder="Select Address"
                    fluid
                    selection
                    disabled
                    options={addressResults || []}
                    label="addressField"
                    id="addressField"
                    name="addressField"
                    onChange={(e, val) =>
                      handleAddressChange(e, val, setFieldValue)
                    }
                    value={addressValue.addressField}
                  />
                </FormGroup>
                {productOptions.length > 0 && <Divider></Divider>}
              </GridColumn>
            </GridRow>
          </Grid>
          <Grid>
            <GridRow>
              <GridColumn>
              {productOptions?.length > 0 &&
              ( 
                <>
                <FormGroup>
                  <Form.Field
                    inline
                    label={"Product Options"}
                    name="optionsLabel"
                    data-testid="optionsLabel"
                  />
                </FormGroup>

                </>
                )}

{productOptions?.some((x) => x.code === "CareLevel") && (
                  <>
                <FormGroup>
                  <Form.Field label="Care Level" required />
                </FormGroup>
                <Grid>
                  <Grid.Row centered>
                    <Grid.Column width={12}>
                      <Form>
                        <FormGroup>
                          <Dropdown
                            placeholder="Select Care Level"
                            fluid
                            search
                            selection
                            options={careLevels}
                            label="careLevelField"
                            id="careLevelField"
                            name="careLevelField"
                            defaultValue={careLevels[0].value}
                            onChange={handleCareLevelChange}
                            value={level.careLevelField}
                          />
                        </FormGroup>
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                </>
                )}

                {productOptions?.some((x) => x.code === "TrafficWeighting") && (
                  <>
                <FormGroup>
                  <Form.Field label="Traffic Weighting" required />
                </FormGroup>
                <Grid>
                  <Grid.Row centered>
                    <Grid.Column width={12}>
                      <Form>
                        <FormGroup>
                          <Dropdown
                            placeholder="Select Traffic Weighting"
                            fluid
                            search
                            selection
                            options={trafficWeighting}
                            label="trafficWeightingField"
                            id="trafficWeightingField"
                            name="trafficWeightingField"
                            defaultValue={trafficWeighting[0].value}
                            onChange={handleTrafficWeightingChange}
                            value={weighting.trafficWeightingField}
                          />
                        </FormGroup>
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                </>
                )}
                {!isL2Customer && (
                  <>
                    <Divider></Divider>
                    <FormGroup>
                      <Form.Field
                        style={{ width: "250px" }}
                        inline
                        label="Credentials"
                        name="credentials"
                        data-testid="credentialsLabel"
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormInput
                        style={{ width: "250px" }}
                        inline
                        label="Username"
                        name="usernameField"
                        data-testid="usernameField"
                        disabled={false}
                        onChange={handleUsernameChange}
                        values={values.usernameField}
                        required
                      />
                      <Dropdown
                        style={{
                          height: "38px",
                          padding: "7px",
                          minWidth: "200px",
                        }}
                        options={realms}
                        id="realm"
                        name="realm"
                        defaultValue={realm}
                        onChange={handleRealmChange}
                        value={realm}
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormInput
                        style={{ width: "250px" }}
                        inline
                        label="Password"
                        name="password"
                        id="password"
                        data-testid="password"
                        value={values.password}
                        onChange={handleChange}
                        required
                      />
                    </FormGroup>
                    {usernameMessage.includes(
                      "The username should be a minimum of 3 characters"
                    ) && (
                      <span className="login__error">{usernameMessage}</span>
                    )}
                    {(usernameMessage.includes("Available") ||
                      usernameMessage.includes("NotAvailable") ||
                      usernameMessage.includes("Invalid")) && (
                      <span className="login__success">{usernameMessage}</span>
                    )}
                  </>
                )}
                {!isL2Customer && (
                  <>
                    <Divider></Divider>
                    <FormGroup>
                      <Form.Field
                        inline
                        label="No of IP Addresses"
                        name="ipsLabel"
                        data-testid="ipsLabel"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Form.Field>
                        <input
                          type="radio"
                          name="noOfIps"
                          value={ips[0].value}
                          defaultChecked
                          className="ui.radio"
                          onChange={(e) => handleRadioChange(e, setFieldValue)}
                        />
                      </Form.Field>
                      <label>1</label>
                      <Form.Field>
                        <input
                          type="radio"
                          name="noOfIps"
                          value={ips[1].value}
                          className="ui.radio"
                          onChange={(e, val) =>
                            handleRadioChange(e, val, setFieldValue)
                          }
                        />
                      </Form.Field>
                      <label>4</label>
                    </FormGroup>
                  </>
                )}

                {permissions?.rateCard && <Divider></Divider>}

                {permissions?.rateCard && (
                  <FormGroup>
                    <Form.Field label="Router" />
                    <Dropdown
                      placeholder="Select Router"
                      fluid
                      selection
                      options={utilities?.routerOptions}
                      value={router}
                      onChange={handleRouterChange}
                      data-testid="routerDropdown"
                    />

                    <Form.Field label="Delivery" required={router !== "None"} />
                    <Dropdown
                      placeholder="Select Delivery Option"
                      fluid
                      selection
                      options={utilities?.deliveryOptions}
                      value={deliveryOptions}
                      onChange={handleDeliveryChange}
                      error={showDeliveryValidation && !deliveryOptions}
                    />
                    {showDeliveryValidation && !deliveryOptions && (
                      <Message
                        error
                        content="Please select a delivery option"
                      />
                    )}
                  </FormGroup>
                )}

{permissions?.isNimansTenant && (
                  <>
                    <Divider></Divider>
                    <FormGroup>
                      <Form.Field
                        inline
                        label="Bureau Reseller"
                        name="bureauResellerLabel"
                        data-testid="bureauResellerLabel"
                        
                      />
                    </FormGroup>
                    <FormGroup>
                      <Checkbox
                        label="This is a Bureau reseller order"
                        name="isBureauReseller"
                        checked={isBureauReseller}
                        onChange={handleBureauResellerChange}
                        data-testid="isBureauResellerCheckbox"
                        style={{ marginLeft: '20px' }} 
                      />
                    </FormGroup>

                    {isBureauReseller && (
                      <FormGroup>
                        <Form.Field
                          label="End Customer Name"
                          required
                          error={errors.bureauEndCustomer}
                        />
                        <Form.Input
                          placeholder="Enter end customer name for billing"
                          name="bureauEndCustomer"
                          value={bureauEndCustomer}
                          onChange={handleBureauEndCustomerChange}
                          data-testid="bureauEndCustomerInput"
                        />
                        {errors.bureauEndCustomer && (
                          <Message
                            error
                            content={errors.bureauEndCustomer}
                            style={{ marginTop: "0.5rem" }}
                          />
                        )}
                      </FormGroup>
                    )}
                  </>
                )}

                <Divider></Divider>
                <FormGroup>
                  <Form.Field label="Contact Details" required />
                </FormGroup>
                <Form.Field>
                  <Form.Input
                    placeholder="Enter Contact Name"
                    id="contactName"
                    name="contactName"
                    value={values.contactName}
                    onChange={handleChange}
                  />
                </Form.Field>
                <Form.Field>
                  <Form.Input
                    placeholder="Enter Contact Telephone Number"
                    id="contactTel"
                    name="contactTel"
                    value={values.contactTel}
                    onChange={handleChange}
                  />
                </Form.Field>
                <Divider></Divider>
                {
                  <ActivationDate
                    show={isActivationDateVisible}
                    today={new Date()}
                    leadTimeDays={10}
                  />
                }

                {permissions?.rateCard && (
                  <>
                    <FormGroup>
                      <Form.Field
                        inline
                        label="Pricing Option"
                        name="pricingOptionLabel"
                        data-testid="pricingOptionLabel"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Form.Field>
                        <Form.Radio
                          label="Rate Card"
                          name="pricingOption"
                          value="rateCard"
                          checked={pricingOption === "rateCard"}
                          onChange={handlePricingOptionChange}
                        />
                      </Form.Field>
                      <Form.Field>
                        <Form.Radio
                          label="Bespoke"
                          name="pricingOption"
                          value="bespoke"
                          checked={pricingOption === "bespoke"}
                          onChange={handlePricingOptionChange}
                        />
                      </Form.Field>
                    </FormGroup>
                    {pricingOption === "bespoke" && (
                      <FormGroup>
                        <Form.Input
                          label="Bespoke Price"
                          placeholder="Enter price"
                          name="bespokePrice"
                          value={bespokePrice}
                          onChange={handlePriceChange}
                          type="number"
                          min="0"
                          step="0.01"
                        />
                      </FormGroup>
                    )}
                    <Divider></Divider>
                  </>
                )}

                {permissions?.pendingOrders && (
                  <Message info>
                    If retrying a pending order, please tick the box below and
                    enter the appropriate partner order reference.
                  </Message>
                )}

                <FormGroup>
                  <Form.Field
                    inline
                    label="References"
                    name="references"
                    data-testid="referencesLabel"
                    disabled={true}
                  />
                </FormGroup>

                {permissions?.pendingOrders && (
                  <FormGroup>
                    <Form.Checkbox
                      label="Retry Order"
                      name="isRetryOrder"
                      checked={isRetryOrder}
                      onChange={handleRetryChange}
                      data-testid="isRetryOrderCheckbox"
                    />
                  </FormGroup>
                )}

                <FormGroup>
                  <FormInput
                    inline
                    label="Order Reference"
                    name="orderRef"
                    data-testid="orderRefLabel"
                    disabled={false}
                    value={values.orderRef}
                    onChange={handleChange}
                    required
                  />
                </FormGroup>
                {( !permissions?.isNimansTenant &&
                <FormGroup>
                  <FormInput
                    inline
                    label="RID"
                    name="rid"
                    data-testid="ridLabel"
                    disabled={false}
                    value={values.rid}
                    onChange={handleChange}
                    required
                  />
                </FormGroup>
                )}
                <Button
                  disabled={!isValid || zenReference}
                  className="button-primary"
                  floated="right"
                  content="Place Order"
                  onClick={handleSubmit}
                  loading={isLoading}
                />
              </GridColumn>
            </GridRow>
          </Grid>
        </Form>
      </Panel>
    </>
  );
}
